exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h4 {\n  margin-top: 20px;\n  color: #2c023b; }\n\nh3 {\n  margin-top: 20px;\n  color: #2c023b;\n  font-size: large; }\n\n.accordion {\n  background-color: #eee;\n  color: #2c023b;\n  cursor: pointer;\n  width: 80%;\n  border: none;\n  text-align: left;\n  outline: none;\n  font-size: 15px;\n  transition: 0.4s;\n  height: 40px; }\n\n.active {\n  font-weight: bold;\n  transition: font-weight 0.2s ease-in-out; }\n\n.accordion:hover {\n  background-color: #23ffea; }\n\n.accordion:after {\n  content: '\\2B9F';\n  color: #777;\n  font-weight: bold;\n  float: right;\n  margin-left: 5px; }\n\n.active:after {\n  content: \"\\2B9D\"; }\n\n.panel {\n  padding: 0 18px;\n  background-color: white;\n  max-height: 0;\n  width: 80%;\n  overflow: hidden;\n  transition: max-height 0.2s ease-out;\n  font-size: 14px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/pages/faq/faq.component.scss
// module id = ../../../../../src/app/pages/faq/faq.component.scss
// module chunks = main